import React from 'react';
import { SidebarType } from '../utils/SidebarStateManager';
import { useSidebarState } from '../hooks/useSidebarState';
import { sidebarStateManager } from '../utils/SidebarStateManager';

interface BaseSidebarProps {
  sidebarType: SidebarType;
  title?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

const BaseSidebar: React.FC<BaseSidebarProps> = ({
  sidebarType,
  children,
  className = '',
}) => {
  const { activeSidebar } = useSidebarState(sidebarStateManager);
  const isOpen = activeSidebar === sidebarType;

  return (
    <div
      className={`
        fixed right-0 bottom-0 md:top-0 
        m-2 md:m-0 
        h-[70vh] md:h-full 
        w-[calc(100vw-16px)] md:w-[400px] 
        bg-gray-50 dark:bg-gray-900
        shadow-lg 
        overflow-hidden 
        z-[1002] 
        flex flex-col 
        transition-transform duration-300 ease-in-out
        rounded-xl
        ${isOpen ? 'translate-x-0 translate-y-0' : 'translate-y-[calc(100%+8px)] md:translate-y-0 md:translate-x-full'}
        ${className}
      `}
    >
     

      {/* Content */}
      <div className="flex-1 overflow-y-auto overflow-x-hidden">
        <div className="custom-scrollbar h-full overflow-x-hidden">
          {children}
        </div>
      </div>
    </div>
  );
};

export default BaseSidebar;